import Typography from '@mui/material/Typography'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { HandleSelectTreatment } from '@customTypes/HandleSelectTreatment'
import { TreatmentBundle } from '@customTypes/TreatmentBundle'
import useStyles from './TreatmentCard.styles'
import { TEST_IDS } from 'src/constants/testIds'

interface Props {
  treatment: Partial<TreatmentBundle>
  handleSelectTreatment: HandleSelectTreatment
  isLast: boolean
  selectedTreatmentId: string | undefined
}

export const TreatmentCard = ({ treatment, handleSelectTreatment, isLast, selectedTreatmentId }: Props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { referenceId, titleKey, descriptionKey, minDurationInMin, maxDurationInMin } = treatment
  const selected = selectedTreatmentId === referenceId
  if (!titleKey || !descriptionKey || !referenceId) return null

  const treatmentName = t(titleKey)
  const treatmentDescription = t(descriptionKey)
  const durationExist = minDurationInMin && maxDurationInMin
  const minAndMaxDurationTheSame = minDurationInMin === maxDurationInMin

  return (
    <>
      <div className={clsx(classes.root)} onClick={() => handleSelectTreatment(referenceId)}>
        <div className={clsx(classes.treatmentInfoContainer, { [classes.selected]: selected })}>
          <div className={classes.treatmentNameContainer}>
            <Typography data-test={TEST_IDS.treatmentCardName} className={classes.treatmentName}>
              {treatmentName}
            </Typography>
            {durationExist && (
              <Typography data-test={TEST_IDS.treatmentCardDuration} className={classes.duration}>
                {minAndMaxDurationTheSame ? minDurationInMin : `${minDurationInMin} - ${maxDurationInMin}`} min
              </Typography>
            )}
          </div>
          <div>
            <Typography variant="Lato Body 2">{treatmentDescription}</Typography>
          </div>
        </div>
      </div>
      {!isLast && <div className={classes.treatmentSeparator} />}
    </>
  )
}
